import React from 'react';
import Breakpoint from './BreakPoint';

export default function MobileLayout(props) {

  return (
    <Breakpoint name="phone">
      {props.children}
    </Breakpoint>
  );
};